import { commonTypes } from '../common';

export const types = {
  SET_CONFIRM_INFO: 'UINEEDS/SET_CONFIRM_INFO',
  SET_CONFIRMATION_TEXTS: 'UINEEDS/SET_CONFIRMATION_TEXTS',
  SET_SHOW_GENESYS_FAIL: 'UINEEDS/SET_SHOW_GENESYS_FAIL',
};

export const initialState = {
  confirmationInfo: null,
  confirmationTexts: [],
  showGenesysFail: false,
};

const UINeedsConfirmationReducer = (state, action) => {
  switch (action.type) {
    case types.SET_SHOW_GENESYS_FAIL: {
      const newState = {
        ...state,
        showGenesysFail: true,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    case types.SET_CONFIRM_INFO: {
      const {
        customerOrder,
      } = action.payload;

      const newState = {
        ...state,
        confirmationInfo: {
          idCO: customerOrder.code,
        },
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case commonTypes.SET_SE_INFO: {
      const {
        idSE,
      } = action.payload;

      const newState = {
        ...state,
        confirmationInfo: {
          ...state.confirmationInfo,
          idSE,
        },
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case commonTypes.SET_GENESYS_OK: {  
      const newState = {
        ...state,
        confirmationInfo: {
          ...state.confirmationInfo,
          genesysOK: true,
        },
      };

      return {
        state: newState,
        stepsMustBeEvaluated: true,
      };
    }
    case types.SET_CONFIRMATION_TEXTS: {
      const {
        texts,
      } = action.payload;

      const newState = {
        ...state,
        confirmationTexts: texts,
      };

      return {
        state: newState,
        stepsMustBeEvaluated: false,
      };
    }
    default:
      return null;
  }
};

export const actions = {
  setConfirmationInfo: info => ({
    type: types.SET_CONFIRM_INFO,
    payload: {
      ...info,
    },
  }),
  setConfirmationTexts: texts => ({
    type: types.SET_CONFIRMATION_TEXTS,
    payload: {
      texts,
    },
  }),
  setShowGenesysFail: () => ({
    type: types.SET_SHOW_GENESYS_FAIL,
  }),
};

export default UINeedsConfirmationReducer;
